import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref } from 'vue';
import { useLoaderStore } from '@/shared/store/useLoaderStore';

export const useCityInfo = (citySlug: MaybeRefOrGetter<string>, enabled: MaybeRefOrGetter<boolean>) => {
  const loaderStore = useLoaderStore();

  const { getCityInfoBySlug } = useExperienceApi();

  const { data: cityInfo } = useQuery({
    queryKey: ['cityInfo', citySlug],
    queryFn: async () => {
      const result = await getCityInfoBySlug({ path: { citySlug: unref(citySlug) as string } });

      loaderStore.check404(result);

      return result;
    },
    enabled: computed(() => !!unref(enabled)),
    select: (response) => response.data,
    retry: false,
  });

  return {
    cityInfo,
  };
};
